import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAutoSelectTriggered } from 'store/slices/autoFlow';
import { resetCategorySelection, selectedCategorySelector, setPrevSelectedCategory } from 'store/slices/methodGrouping';

export const useResetCategoryAutoSelect = () => {
  const dispatch = useAppDispatch();
  const selectedCategory = useAppSelector(selectedCategorySelector);

  return useCallback(() => {
    if (selectedCategory) {
      dispatch(resetCategorySelection(selectedCategory));
    }
    dispatch(setAutoSelectTriggered());
    dispatch(setPrevSelectedCategory(null));
  }, [dispatch, selectedCategory]);
};
